import axios, {AxiosResponse} from "axios";
import {Task, TaskImport, TaskImportRequest, TaskRequest} from "@/model/OrderTaskImport";

const PATH_V2 = "/v2/tasks";
const PATH_ORDERS_V2 = "/v2/orders";

class OrderTaskService {

    // region ORDER TASK IMPORT (v2), addressed by the order's uuid
    // Answers 404 when the order has no import
    getTaskImport(orderUuid: string): Promise<AxiosResponse<TaskImport>> {
        return axios.get(`${PATH_ORDERS_V2}/${orderUuid}/task-import`);
    }

    // Replaces the order's import in one step; the tasks added after the import are kept
    importTasks(orderUuid: string, request: TaskImportRequest): Promise<AxiosResponse<TaskImport>> {
        return axios.put(`${PATH_ORDERS_V2}/${orderUuid}/task-import`, request);
    }

    // Removes the imported tasks; the tasks added after the import are kept
    deleteTaskImport(orderUuid: string): Promise<AxiosResponse<void>> {
        return axios.delete(`${PATH_ORDERS_V2}/${orderUuid}/task-import`);
    }

    // endregion

    // region TASK (v2), addressed by uuids
    findTasks(date: string): Promise<AxiosResponse<{ tasks: Array<Task> }>> {
        return axios.get(PATH_V2, {
            params: {
                date: date
            }
        });
    }

    addTask(orderUuid: string, request: TaskRequest): Promise<AxiosResponse<Task>> {
        return axios.post(`${PATH_ORDERS_V2}/${orderUuid}/tasks`, request);
    }

    updateTask(taskUuid: string, request: TaskRequest): Promise<AxiosResponse<Task>> {
        return axios.put(`${PATH_V2}/${taskUuid}`, request);
    }

    completeTask(taskUuid: string): Promise<AxiosResponse<Task>> {
        return axios.post(`${PATH_V2}/${taskUuid}/complete`);
    }

    reopenTask(taskUuid: string): Promise<AxiosResponse<Task>> {
        return axios.post(`${PATH_V2}/${taskUuid}/reopen`);
    }

    // endregion
}

export default new OrderTaskService();
